(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/customer-service/views/start.js') >= 0) return;  svs.modules.push('/modules/customer-service/views/start.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.customer_service=_svs.customer_service||{};
_svs.customer_service.templates=_svs.customer_service.templates||{};
svs.customer_service.templates.start = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "\n  <div id=\"help\"></div>\n";
},"useData":true});
Handlebars.partials['svs-customer_service-start'] = svs.customer_service.templates.start;
})(svs, Handlebars);

 })(window);